import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import { CollegeCard } from "../../shared/component/Card/Card";
import * as RoutePath from "../../shared/utils/routeLink";
import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
import ListingComponent from "../../shared/component/ListingComponent/ListingComponent";
import FilterBox from "../../shared/component/FilterBox/FilterBox";
import NoContentComponent from "../../shared/component/NoContentComponent/NoContentComponent";
import { toast } from "react-toastify";
import ViewMoreBox from "../../shared/component/FilterBox/ViewMoreBox";
import makeRequest from "../../shared/utils/request";
import { generateRequestOptions } from "../../shared/utils/apiEndPoints";
import { formatString } from "../../shared/utils/string";
import useDebounce from "../../shared/hooks/debounce";
import { SearchIcon } from "../../shared/component/svg/Icons";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import { CollegeListCard } from "../../shared/component/ListItem/ListItem";

const ITEMS_PER_PAGE = 60;

const DomesticStaticCity = ['Jakarta', 'Bandung', 'Surabaya']

const predefinedAbroad = [
    {
        name: "Korea Selatan",
        label: "KR",
    },
    {
        name: "Taiwan",
        label: "TW",
    },
    {
        name: "Kanada",
        label: "CA",
        cities: [
            {
                city: "Toronto",
                colleges_cnt: 2
            },
            {
                city: "Victoria",
                colleges_cnt: 1
            },
            {
                city: "Ottawa",
                colleges_cnt: 3
            }
        ]
    }
]

const ACCREDITATION_OPT_LEFT = [
	{ id: "A", name: "A" },
	{ id: "B", name: "B" },
	{ id: "C", name: "C" },
];
const ACCREDITATION_OPT_RIGHT = [
	{ id: "Unggul", name: "Unggul" },
	{ id: "Baik Sekali", name: "Baik Sekali" },
	{ id: "Baik", name: "Baik" },
];

const SCHOLARSHIP_OPT = [
	{ id: true, name: Variable.YES },
	{ id: false, name: Variable.NO },
];
let controller = new AbortController();

const CollegeListing = ({ ENV_NAME, isAuthenticated, fetchingAddRemoveFavorites, ...props }) => {
	const [colleges, setColleges] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingFilters, setIsLoadingFilters] = useState(false);
	const [isLoadingLocations, setIsLoadingLocations] = useState(false);
	// const [isLoadingAccreditation, setIsLoadingAccreditation] = useState(false);
	const [viewMore, setViewMore] = useState({});
	const [filters, setFilters] = useState({
		scholarship: "allScholarship",
		domestic: {
			domesticAll: true,
		},
		abroad: {
			abroadAll: false,
		},
        majors: {
            majorsAll :false
        },
        countryAll : {},
        totalLengthCountry: {}
	}); 
	const [topLocations, setTopLocations] = useState({});
	const [locations, setLocations] = useState({});
	const [majors, setMajors] = useState([]);
	// const [abroadAccreditations, setAbroadAccreditations] = useState([]);
	const [searchTemp, setSearchTemp] = useState("");
	const debounceSearch = useDebounce(searchTemp, 750);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState({
		has_next: false,
		total_items: 0,
	});
	const [view, setView] = useState("big");
	let location = useLocation();
	const [activeSwitcher, setActiveSwitcher] = useState('domestic');

	useEffect(() => {
		if (searchTemp !== filters?.search && (searchTemp.length >= 3 || searchTemp === "")) {
			setFilters((p) => ({ ...p, search: debounceSearch }));
		}
	}, [debounceSearch]); // eslint-disable-line

	useEffect(() => {
		// Cancel API call, this is actually a bad way to do this,
		// but at the moment no other solution in hand
		// if (isLoading) {
		// 	controller.abort();
		// 	controller = new AbortController();
		// 	setIsLoading(false);
		// }
		setPage(1);
        getColleges(1);
	
	}, [filters]); // eslint-disable-line

	useEffect(() => {
		if (page > 1) getColleges(page);
	}, [page]); // eslint-disable-line

	useEffect(() => {
		getFilters();
	}, []);

	useEffect(() => {
		let city = new URLSearchParams(location.search).get("city");
		if (city) {
			setFilters((p) => ({ ...p, locations: { ...p?.locations, [city]: true } }));
		}
	}, [location]); // eslint-disable-line

	useEffect(() => {
		// Big code ahead
		// So when we're using URL to get the location, 
		// we cannot determine whether the location is abraoad or domestic
		// This code sort of searches for the location listing and if they find in either
		// domestic or abroad, we set the filter there directly
		if (filters?.locations && topLocations?.domestic && topLocations?.abroad) {
			let p = filters;
			Object.keys(filters?.locations || {})
				?.filter((i) => filters?.locations?.[i])
				?.forEach((i) => {
					let domestic = topLocations?.domestic
						?.find((j) => j?.id?.toLowerCase() === i?.toLowerCase());
					let abroad = topLocations?.abroad
						?.find((j) => j?.id?.toLowerCase() === i?.toLowerCase());
					if (domestic) p = { ...p, domestic: { ...p?.domestic, [i]: true }, locations: undefined };
					if (abroad) p = { ...p, abroad: { ...p?.abroad, [i]: true }, locations: undefined };
				});
			setFilters(p);
		}
		if (filters?.locations && locations?.domestic && topLocations?.abroad) {
			let p = filters;
			Object.keys(filters?.locations || {})
				?.filter((i) => filters?.locations?.[i])
				?.forEach((i) => {
					let domestic = locations?.domestic
						?.find((j) => j?.id?.toLowerCase() === i?.charAt(0)?.toLowerCase())
						?.children?.find((j) => j?.id?.toLowerCase() === i?.toLowerCase());
					let abroad = locations?.abroad
						?.find((j) => j?.id?.toLowerCase() === i?.charAt(0)?.toLowerCase())
						?.children?.find((j) => j?.id?.toLowerCase() === i?.toLowerCase());
					if (domestic) p = { ...p, domestic: { ...p?.domestic, [i]: true }, locations: undefined };
					if (abroad) p = { ...p, abroad: { ...p?.abroad, [i]: true }, locations: undefined };
				});
			setFilters(p);
			
		}
	}, [filters?.locations, locations, topLocations]); // eslint-disable-line

	const getFilters = async () => {
		setIsLoadingFilters(true);

		// let promise1 = makeRequest(
		// 	generateRequestOptions("topCitiesView", { queryParams: { location_type: "domestic" } })
		// );
		let promise3 = makeRequest(generateRequestOptions("majorNameList"));

		let [majors] = await Promise.all([promise3]);
		let locationWithCount = await makeRequest(
            generateRequestOptions("locationListWithCount", {
                queryParams: { location_type: "domestic"},
            })
        );

        let locations = {};

        if(locationWithCount?.code===200) {
            const result = DomesticStaticCity.map(city => {
                const obj = Object.values(locationWithCount?.data).flat().find(item => Object.keys(item)[0] === city);
                const colleges_count = obj ? obj[city] : 0;
                return { id:city, name: city, colleges_count };
            });

            locations["domestic"] = result;

        }

		// if (topCitiesDomestic?.code === 200) {
		// 	locations["domestic"] = topCitiesDomestic?.data?.map((i) => ({
		// 		id: i?.city,
		// 		name: i?.city,
		// 		colleges_count: i?.colleges_cnt
		// 	}));
		// }
            const predefinedAbroadFix = predefinedAbroad.map(async(abroad) => {
                
                if (abroad.label !== "CA") {
                    let promiseCities = await makeRequest(
                        generateRequestOptions("topCitiesView", { queryParams: { location_type: "abroad",
                        country: abroad.label
                    } })
                    );
                    if(promiseCities?.code === 200) {
                        return {
                            ...abroad,
                            name: abroad.name,
                            cities: promiseCities.data
                        }
                    }
                }
                return {
                    ...abroad
                }
            })

            const promiseAbroad = await Promise.all(predefinedAbroadFix);
            locations["abroad"] = promiseAbroad;
        
		setTopLocations(locations);
		if (majors?.code === 200) {
            const majorsObj = Object.entries(majors?.data).map((major)=>{
                return {
                    name: major[0],
                    count_majors: major[1]
                }
            });
            
            
            const predefinedMajors = ['Kedokteran - S-1 Sarjana', 'Akuntansi - S-1 Sarjana', 'Ilmu Hukum - S-1 Sarjana'];



			// setMajors([
			// 	...new Set(predefinedMajors?.concat(majorsObj)?.filter((i)=> !predefinedMajors?.includes(i.name)))
			// ]);

            const matchingMajors = majorsObj.filter((item) =>
                predefinedMajors.includes(item.name)
            );
            const otherMajors = majorsObj.filter(
                (item) => !predefinedMajors.includes(item.name)
            );

            // Sort the matchingMajors based on predefinedMajors order
            const sortedMatchingMajors = matchingMajors.sort((a, b) => {
                const indexA = predefinedMajors.indexOf(a.name);
                const indexB = predefinedMajors.indexOf(b.name);
                return indexA - indexB;
            });

            // Combine the sorted matchingMajors and otherMajors arrays
            const combinedArray = sortedMatchingMajors.concat(otherMajors);
            setMajors(combinedArray);
		}

		setIsLoadingFilters(false);
	};

	const getLocations = async (type = "domestic", country) => {
		setIsLoadingLocations(true);

		// let locations = await makeRequest(
		// 	generateRequestOptions("locationList", {
		// 		queryParams: { location_type: type },
		// 	})
		// );

        if(country === "allCountries") {
            const locationWithCount = predefinedAbroad.map(async (cc) => {
                let locations = await makeRequest(
                    generateRequestOptions("locationListWithCount", {
                        queryParams: { location_type: type, ...(type === "abroad" && {country: cc.label })},
                    })
                );

            
                if (locations?.code === 200 ) {
                    return {
                        country_name: cc.name,
                        country_label: cc.label,
                        cities: locations.data
                    };
                }
                // if (locations?.code === 200) {
                //     const combinedArray = Object.entries(locations.data).reduce(
                //         (result, [key, values]) => {
                //             const properties = values.map((item) => {
                //                 const [property, value] =
                //                     Object.entries(item)[0]
                //                 return { [property]: value }
                //             })
                //             return result.concat(properties)
                //         },
                //         []
                //     )
                //     let newLocations = {};
                //     Object.keys(locations?.data)?.forEach((i) => {
                //         let currData = Object.values(locations?.data?.[i]) || [];
                //         let newCurrData = newLocations?.[i] || [];
                //         currData?.forEach((loc) => {
                //             if (Object.keys(loc)[0].toLowerCase()?.includes("kabupaten")) {
                //                 let firstElem = Object.keys(loc)[0].split(" ")?.[1]?.[0];
                //                 if (newLocations?.[firstElem]?.length) {
                //                     newLocations[firstElem] = [...newLocations?.[firstElem], {name: Object.keys(loc)[0], colleges_count: Object.values(loc)[0]}];
                //                 } else {
                //                     newLocations[firstElem] = [{name:Object.keys(loc)[0],colleges_count:Object.values(loc)[0]}];
                //                 }
                //             } else {
                //                 newCurrData.push({name: Object.keys(loc)[0], colleges_count: Object.values(loc)[0]});
                //             }
                //         });
        
                //         newLocations[i] = newCurrData?.sort((a, b) => {
                //             let newA = a.name?.replace("Kabupaten ", "");
                //             let newB = b.name?.replace("Kabupaten ", "");
                //             return newA?.localeCompare(newB);
                //         });
                //     });
                //     let locRes = Object?.keys(newLocations)?.map((i) => {
                //         return ({
                //             id: i,
                //             name: i,
                //             children: [...new Set(newLocations?.[i])]?.map((j) => {
                //                 return ({
                //                 id: j.name,
                //                 name: j.name,
                //                 colleges_count: j.colleges_count,
                //             })}),
                //         })
                //     });
                //     setLocations((p) => ({ ...p, [type]: locRes }));
                // }
            })

            const promiseAbroad = await Promise.all(locationWithCount);
            const transformedResponse = promiseAbroad.map(({ country_name, country_label, cities }) => ({
                country_name,
                country_label,
                cities: Object.entries(cities).reduce((arr, [key, [value]]) => {
                  arr.push({ [key]: value });
                  return arr;
                }, [])
                  .map(obj => ({name: Object.keys(Object.values(obj)[0])[0], colleges_count: Object.values(Object.values(obj)[0])[0]}))
              }));

           setLocations((p) => ({ ...p, [type]: transformedResponse }));
           setIsLoadingLocations(false);
           return;
        }

        let locations = await makeRequest(
			generateRequestOptions("locationListWithCount", {
				queryParams: { location_type: type, ...(type === "abroad" && {country: country}) },
			})
		);

		// if (locations?.code === 200) {
		// 	let newLocations = {};
		// 	Object.keys(locations?.data)?.forEach((i) => {
		// 		let currData = locations?.data?.[i] || [];
		// 		let newCurrData = newLocations?.[i] || [];
		// 		currData?.forEach((loc) => {
		// 			if (loc?.toLowerCase()?.includes("kabupaten")) {
		// 				let firstElem = loc.split(" ")?.[1]?.[0];
		// 				if (newLocations?.[firstElem]?.length) {
		// 					newLocations[firstElem] = [...newLocations?.[firstElem], loc];
		// 				} else {
		// 					newLocations[firstElem] = [loc];
		// 				}
		// 			} else {
		// 				newCurrData.push(loc);
		// 			}
		// 		});
		// 		newLocations[i] = newCurrData?.sort((a, b) => {
		// 			let newA = a?.replace("Kabupaten ", "");
		// 			let newB = b?.replace("Kabupaten ", "");
		// 			return newA?.localeCompare(newB);
		// 		});
		// 	});
		// 	let locRes = Object?.keys(newLocations)?.map((i) => 
            
        //     {
        //         return ({
        //             id: i,
        //             name: i,
        //             children: [...new Set(newLocations?.[i])]?.map((j) => {
        //                 return ({
        //                 id: j,
        //                 name: j,
        //             })}),
        //         })
        //     });

		// 	setLocations((p) => ({ ...p, [type]: locRes }));
		// }

        if (locations?.code === 200) {
			let newLocations = {};
			Object.keys(locations?.data)?.forEach((i) => {
				let currData = Object.values(locations?.data?.[i]) || [];
				let newCurrData = newLocations?.[i] || [];
				currData?.forEach((loc) => {
					if (Object.keys(loc)[0].toLowerCase()?.includes("kabupaten")) {
						let firstElem = Object.keys(loc)[0].split(" ")?.[1]?.[0];
						if (newLocations?.[firstElem]?.length) {
							newLocations[firstElem] = [...newLocations?.[firstElem], {name: Object.keys(loc)[0], colleges_count: Object.values(loc)[0]}];
						} else {
							newLocations[firstElem] = [{name:Object.keys(loc)[0],colleges_count:Object.values(loc)[0]}];
						}
					} else {
						newCurrData.push({name: Object.keys(loc)[0], colleges_count: Object.values(loc)[0]});
					}
				});

				newLocations[i] = newCurrData?.sort((a, b) => {
					let newA = a.name?.replace("Kabupaten ", "");
					let newB = b.name?.replace("Kabupaten ", "");
					return newA?.localeCompare(newB);
				});
			});
			let locRes = Object?.keys(newLocations)?.map((i) => {
                return ({
                    id: i,
                    name: i,
                    children: [...new Set(newLocations?.[i])]?.map((j) => {
                        return ({
                        id: j.name,
                        name: j.name,
                        colleges_count: j.colleges_count,
                    })}),
                })
            });

			setLocations((p) => ({ ...p, [type]: locRes }));
		}
		setIsLoadingLocations(false);
	};

	// const getAbroadAccreditations = async () => {
	// 	setIsLoadingAccreditation(true);

	// 	let res = await makeRequest(generateRequestOptions("abroadAccreditationList"));

	// 	if (res?.code === 200) {
	// 		setAbroadAccreditations(
	// 			(res?.data || [])?.map(
	// 				(i) =>
	// 					i && {
	// 						id: i,
	// 						name: i,
	// 					}
	// 			)
	// 		);
	// 	}
	// 	setIsLoadingAccreditation(false);
	// };

	const handleClickSwitcher = (e) => {
        if (activeSwitcher === 'domestic') {
            setActiveSwitcher('abroad')
            setFilters({
                ...filters,
                abroad: {abroadAll: true},
                domestic: { domesticAll: false },
                allCities: {},
                countryAll: {},
                majors:{},
                search: "",
                totalLengthCountry: {}
            })
        } else {
            setActiveSwitcher('domestic')
            setFilters({
                ...filters,
                abroad: { abroadAll: false },
                domestic: { domesticAll: true },
                countryAll: {},
                allCities: {},
                majors:{},
                search: "",
                totalLengthCountry: {}
            })
        }
    }

	const getColleges = async (page) => {
		// if (isLoading) return;
		setIsLoading(true);

		// Store the current value, and add the loading card
		// While the API is calling
		let currColleges = page === 1 ? [] : colleges || [];
		setColleges([
			...currColleges,
			...[...Array(ITEMS_PER_PAGE)].map((i) => ({
				isLoading: true,
			})),
		]);

		let combinedAccreditation = { ...(filters?.accreditation || {}), ...(filters?.abroadAccreditation || {}) };
		let tempMajors = filters?.majors?.["majorsAll"] ? {} : filters?.majors;
		let tempAccreditation = combinedAccreditation?.["noAccreditation"] ? "noAccreditation" : combinedAccreditation;
		let scholarship = filters?.scholarship === "allScholarship" ? undefined : filters?.scholarship;
		let tempLocationsNoParts = Object.keys(filters?.locations || {})?.filter((i) => filters?.locations?.[i]);
		let tempDomestic = filters?.domestic?.domesticAll
			? "domestic"
			: Object.keys(filters?.domestic || {})?.filter((i) => filters?.domestic?.[i] && i !== "Jakarta");
		let tempAbroad = filters?.abroad?.abroadAll
			? "abroad"
			: Object.keys(filters?.abroad || {})?.filter((i) => filters?.abroad?.[i]);

		let tempLocations, tempLocationType;
		if (tempDomestic === "domestic" && tempAbroad === "abroad") {
			// Do nothing, we don't pass anything in the filter
		} else if (tempDomestic === "domestic") {
			// If selected all domestic, set the location type
			tempLocationType = "domestic";
		} else if (tempAbroad === "abroad") {
			// If selected all abroad, set the location type
			tempLocationType = "abroad";
		} 

		if (tempDomestic !== "domestic") {
			// Fill domestic locations
			tempLocations = [...(tempLocations || []), ...(tempDomestic || [])];
		}
		if (tempAbroad !== "abroad") {
			// Fill abroad locations
			tempLocations = [...(tempLocations || []), ...(tempAbroad || [])];
		}
		tempLocations = [...(tempLocations || []), ...(tempLocationsNoParts || [])];

        const checkLocations = Object.values(filters.countryAll).includes(true)
        const countryParams = Object.entries(filters?.countryAll).filter((y)=>y[1] === true).map((z)=>z[0]);
        const majorParams = Object.keys(tempMajors || {})?.filter((i) => filters?.majors?.[i]);
        const accrediationParams = Object.keys(tempAccreditation || {})?.filter((i) => tempAccreditation?.[i])


		// Call the API
		let res = await makeRequest({
			...generateRequestOptions("collegeList", {
				queryParams: {
					page,
					page_size: ITEMS_PER_PAGE,
					search: filters.search || null,
                    ...(!checkLocations && {locations: tempLocations}),
					location_type: tempLocationType,
                    ...(countryParams && {country: countryParams}),
					majors: majorParams,
					accreditation:
						tempAccreditation === "noAccreditation"
							? undefined
							: accrediationParams,
					has_scholarship: scholarship,
				},
				queryOptions: { arrayFormat: "repeat" },
			}),
			signal: controller.signal,
		});
		if (res.code === 200) {
			setColleges([...currColleges, ...res.data]);
			setTotal({ has_next: res.next, total_items: res.total_items });
		} else {
			setColleges(currColleges);
			setTotal((p) => ({ ...p, has_next: false }));
			toast.error(res?.message || Variable.SOMETHING_WENT_WRONG_TRY_AGAIN[ENV_NAME]);
		}

		setIsLoading(false);
	};

	const onChangeField = async (e, parent, radio = false, country, allCountry = false) => {
		if (radio) {
			setFilters((p) => ({ ...p, [parent]: e.target.id }));
		} else {
			// Special for Jakarta
			if (parent === "domestic" && e.target.name?.includes("jakarta")) {
				let hasJakartas = locations?.domestic
					?.find((j) => j?.id === "J")
					?.children?.filter((j) => j?.id?.toLowerCase()?.includes("jakarta"));

				if (e.target.name === "Jakarta") {
					hasJakartas = hasJakartas?.reduce((acc, curr) => ({ ...acc, [curr?.id]: e.target.checked }), {});
				}

				setFilters((p) => ({
					...p,
					locations: {
						...p?.[parent],
						Jakarta: e.target.name === "Jakarta" ? e.target.checked : false,
						...(e.target.name === "Jakarta"
							? hasJakartas
							: {
									[e.target.name]: e.target.checked,
							}),
					},
				}));
			}
			if (
				(parent === "accreditation" || parent === "abroadAccreditation") &&
				e.target.name?.includes("noAccreditation")
			) {
				setFilters((p) => ({
					...p,
					accreditation: {
						noAccreditation: e.target.value,
					},
					abroadAccreditation: {},
				}));
			} else if (parent === "accreditation" || parent === "abroadAccreditation") {
				setFilters((p) => ({
					...p,
					[parent]: {
						...p?.[parent],
						[e.target.name]: e.target.checked,
					},
					accreditation: {
						...p?.accreditation,
						noAccreditation: false,
					},
				}));
			}

			setFilters((p) => ({
                ...p,
                [parent]: {
                    ...p?.[parent],
                    // checking the location filter if its checked or not then set the [parent + "All"] to true or false
                    // [parent + "All"]: (parent === 'domestic' || parent === 'abroad') && ( Object.values({...p[parent], [e.target.name] : e.target.checked}).every(e => e === false)  ? true : false ) : {...(p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {})},
                    // ...(p?.[parent]?.[parent + "All"] (parent !== 'domestic' || parent !== 'abroad') && !e.target.checked ? { [parent + "All"]: false } : {})  ,
                    [parent + 'All']:
                        // (parent === 'domestic' || parent === 'abroad') &&
                        ((parent === "domestic" || parent === "abroad") && Object.values({
                            ...p[parent],
                            [e.target.name]: e.target.checked,
                        }).every((e) => e === false)
                            ? true
                            : false),
                            // ...(p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
                    ...(!allCountry &&  {[e.target.name] : e.target.checked}),
                    ...((parent!== "domestic" || parent!== "abroad") && p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
                    ...((parent==="abroad" && allCountry) && p?.[parent]?.[parent + "All"] && !e.target.checked ? { [parent + "All"]: false } : {}),
                },
                ...(!allCountry  && parent==="abroad" &&   { 
                    allCities: {
                        ...p.allCities,
                        [country]: {
                            ...p.allCities?.[country],
                            [e.target.name]: e.target.checked
                        }
                    }
                }),
                ...(allCountry &&  {
                    countryAll: {
                        ...p.countryAll,
                        [e.target.name] : e.target.checked
                    },
                    ...(!e.target.checked && {totalLengthCountry: {
                        ...p?.totalLengthCountry,
                        [country]:null
                    }})
                }),
                ...(!allCountry &&  {
                    countryAll: {
                        ...p.countryAll,
                        [country] : false
                    },
                }),
            }))	

            if(allCountry && !filters.countryAll?.[country]){           
                const locations =  await makeRequest(generateRequestOptions("locationListWithCount", { queryParams: { country: e.target.name, location_type: 'abroad' } })
                );
                // let promise3 = makeRequest(generateRequestOptions("majorNameList"));

                if (locations?.code === 200) {
                    const totalLength = Object.values(locations.data).reduce((acc, arr) => acc + arr.length, 0);
                    setFilters((p)=>{
                        return {
                            ...p,
                            totalLengthCountry: {
                                ...p?.totalLengthCountry,
                                [country]:totalLength
                            }
                        }
                    })
                }
            }
		}
	};

	const openViewMore = (name, open = true) => {
		setViewMore((p) => ({ ...p, [name]: open }));
	};

    const getSelectedFilterCount = (type, isMajors = false, city = false, country = false) => {
        if (!!isMajors) {
            if (filters.majors.majorsAll) {
                return majors.length
            }
        }
        
        if(!!type && !!city) {
        return Object.values(type)
        .slice(0, type.length)
        .filter((e) => e === true).length
        
       }

       if(!!type && !!country) {
        return Object.values(type)
        .slice(0, type.length)
        .filter((e) => e === true).length
       }

       if(!!type && !country && !city) {
        return Object.values(type)
        .slice(1, type.length)
        .filter((e) => e === true).length
       }
       
    }
     

	return (
        <ListingComponent
            className="college-listing"
            hasView={true}
            view={view}
            setView={setView}
            handleClickSwitcher={handleClickSwitcher}
            activeSwitcher={activeSwitcher}
            isCollege
            filters={
                <>
                    <FilterBox>
                        <div className="form-group search-bar mb-0">
                            <SearchIcon className="searchIcon" />
                            <input
                                type="text"
                                name="searchText"
                                value={searchTemp || ''}
                                onChange={(e) => setSearchTemp(e.target.value)}
                                placeholder={formatString(
                                    Variable.SRC_BY_PLACEHOLDER[ENV_NAME],
                                    Variable.COLLEGE[ENV_NAME]
                                )}
                            />
                        </div>
                    </FilterBox>
                    <FilterBox
                        header={Variable.LOCATION[ENV_NAME]}
                        collapsible={1}
                        eventkey="0"
                        opendefault={1}
                    >
                        {isLoadingFilters ? (
                            <LoadingComponent notFullScreen loadingLabel=" " />
                        ) : (
                            <>
                                {/* DOMESTIC LOCATIONS */}
                                {activeSwitcher === 'domestic' && (
                                    <div>
                                        {(
                                            topLocations?.domestic?.slice(
                                                0,
                                                3
                                            ) || []
                                        )?.map((i, idx) => (
                                            <div
                                                className="form-group form-check"
                                                key={'locationsDomestic-' + idx}
                                            >
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={i?.id}
                                                        name={i?.id}
                                                        checked={
                                                            filters?.domestic?.[
                                                                i?.id
                                                            ] || false
                                                        }
                                                        onChange={(e) =>
                                                            onChangeField(
                                                                e,
                                                                'domestic',
                                                                false
                                                            )
                                                        }
                                                        disabled={isLoading}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={i?.id}
                                                    >
                                                        {i?.name}{' '}
                                                        <span className="filter-count">
                                                            ({i?.colleges_count}
                                                            )
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                        <button
                                            className="btn btn-view-more"
                                            onClick={() => {
                                                getLocations('domestic')
                                                openViewMore('domestic', true)
                                            }}
                                        >
                                            {
                                                Variable.VIEW_MORE_DOMESTIC[
                                                    ENV_NAME
                                                ]
                                            }{' '}
                                            {!filters.domestic.domesticAll &&
                                                `(${getSelectedFilterCount(
                                                    filters.domestic
                                                )} ${
                                                    Variable.APPLIED[ENV_NAME]
                                                })`}
                                        </button>
                                    </div>
                                )}

                                {/* ABROAD LOCATIONS */}
                                {activeSwitcher === 'abroad' && (
                                    <div>
                                        {(
                                            topLocations?.abroad?.slice(0, 3) ||
                                            []
                                        )?.map((i, idx) => (
                                            <>
                                                <div
                                                    className="form-group form-check"
                                                    key={
                                                        'locationsAbroad-' + idx
                                                    }
                                                >
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input text-bold text-label-black"
                                                            id={i?.label}
                                                            name={i?.label}
                                                            checked={
                                                                filters
                                                                    .countryAll?.[
                                                                    i?.label
                                                                ] || false
                                                            }
                                                            onChange={(e) =>
                                                                onChangeField(
                                                                    e,
                                                                    'abroad',
                                                                    false,
                                                                    i?.label,
                                                                    true
                                                                )
                                                            }
                                                            disabled={isLoading}
                                                        />
                                                        <label
                                                            className="form-check-label big-label"
                                                            htmlFor={i?.label}
                                                        >
                                                            {i?.name}
                                                        </label>
                                                        <div className="mt-2">
                                                            {i?.cities.map(
                                                                (j) => (
                                                                    <div className="form-group form-check">
                                                                        <div className="custom-control custom-checkbox">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id={
                                                                                    j.city
                                                                                }
                                                                                name={
                                                                                    j.city
                                                                                }
                                                                                checked={
                                                                                    filters
                                                                                        .countryAll?.[
                                                                                        i
                                                                                            ?.label
                                                                                    ] ||
                                                                                    filters
                                                                                        ?.abroad?.[
                                                                                        j
                                                                                            ?.city
                                                                                    ] ||
                                                                                    false
                                                                                }
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    onChangeField(
                                                                                        e,
                                                                                        'abroad',
                                                                                        false,
                                                                                        i?.label
                                                                                    )
                                                                                }
                                                                                disabled={
                                                                                    isLoading
                                                                                }
                                                                            />
                                                                            <label
                                                                                className="form-check-label"
                                                                                htmlFor={
                                                                                    j?.city
                                                                                }
                                                                            >
                                                                                {
                                                                                    j?.city
                                                                                }
                                                                                <span className="filter-count">{`(${j?.colleges_cnt})`}</span>
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                    <button
                                                        className="btn btn-view-more"
                                                        onClick={() => {
                                                            getLocations(
                                                                'abroad',
                                                                i?.label
                                                            )
                                                            openViewMore(
                                                                i?.label,
                                                                true
                                                            )
                                                        }}
                                                    >
                                                        {
                                                            Variable
                                                                .VIEW_MORE_CITY[
                                                                ENV_NAME
                                                            ]
                                                        }
                                                        {filters.allCities &&
                                                            filters.allCities?.[
                                                                i?.label
                                                            ] &&
                                                            filters.allCities !==
                                                                undefined &&
                                                            !!getSelectedFilterCount(
                                                                filters
                                                                    .allCities?.[
                                                                    i?.label
                                                                ],
                                                                false,
                                                                true
                                                            ) &&
                                                            `(${getSelectedFilterCount(
                                                                filters
                                                                    ?.allCities?.[
                                                                    i?.label
                                                                ],
                                                                false,
                                                                true
                                                            )} ${
                                                                Variable
                                                                    .APPLIED[
                                                                    ENV_NAME
                                                                ]
                                                            })`}
                                                        {filters.totalLengthCountry &&
                                                            filters
                                                                .totalLengthCountry[
                                                                i?.label
                                                            ] &&
                                                            `(${filters
                                                                .totalLengthCountry[
                                                                i?.label
                                                            ] } ${Variable.APPLIED[ENV_NAME]})`}
                                                    </button>
                                                </div>
                                                <ViewMoreBox
                                                    open={
                                                        viewMore[i?.label] ||
                                                        false
                                                    }
                                                    onHide={() =>
                                                        openViewMore(
                                                            i?.label,
                                                            false
                                                        )
                                                    }
                                                    data={
                                                        locations?.abroad || []
                                                    }
                                                    parent="abroad"
                                                    filters={filters}
                                                    onSave={(data) =>
                                                        setFilters((p) => ({
                                                            ...p,
                                                            ...data,
                                                            abroad: {
                                                                ...data?.abroad,
                                                            },
                                                        }))
                                                    }
                                                    searchPlaceholder={
                                                        Variable.SRC_LOCATION[
                                                            ENV_NAME
                                                        ]
                                                    }
                                                    isLoading={
                                                        isLoadingLocations
                                                    }
                                                    withCount
                                                    country={i?.label}
                                                />
                                            </>
                                        ))}
                                        <button
                                            className="btn btn-view-more"
                                            onClick={() => {
                                                getLocations(
                                                    'abroad',
                                                    'allCountries'
                                                )
                                                openViewMore('abroad', true)
                                            }}
                                        >
                                            {
                                                Variable.VIEW_MORE_COUNTRY[
                                                    ENV_NAME
                                                ]
                                            }
                                            {!!getSelectedFilterCount(
                                                filters.countryAll,
                                                false,
                                                false,
                                                true
                                            ) &&
                                                `(${getSelectedFilterCount(
                                                    filters.countryAll,
                                                    false,
                                                    false,
                                                    true
                                                )} ${
                                                    Variable.APPLIED[ENV_NAME]
                                                })`}
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </FilterBox>
                    <ViewMoreBox
                        open={viewMore?.domestic || false}
                        onHide={() => openViewMore('domestic', false)}
                        data={locations?.domestic || []}
                        parent="domestic"
                        filters={filters}
                        onSave={(data) =>
                            setFilters((p) => ({
                                ...p,
                                ...data,
                                domestic: { ...data?.domestic },
                            }))
                        }
                        searchPlaceholder={Variable.SRC_LOCATION[ENV_NAME]}
                        isLoading={isLoadingLocations}
                        withCount
                    />
                    <ViewMoreBox
                        open={viewMore?.abroad || false}
                        onHide={() => openViewMore('abroad', false)}
                        data={locations?.abroad || []}
                        parent="abroad"
                        filters={filters}
                        onSave={(data) =>
                            setFilters((p) => ({
                                ...p,
                                ...data,
                                abroad: {
                                    ...data?.abroad,
                                },
                            }))
                        }
                        searchPlaceholder={Variable.SRC_LOCATION[ENV_NAME]}
                        isLoading={isLoadingLocations}
                        withCount
                        // country={i?.label}
                        allCountry
                    />
                    <FilterBox
                        header={Variable.MAJOR[ENV_NAME]}
                        collapsible={1}
                        eventkey="1"
                        opendefault={1}
                    >
                        {isLoadingFilters ? (
                            <LoadingComponent notFullScreen loadingLabel=" " />
                        ) : (
                            <>
                                <div className="form-group form-check">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="majorsAll"
                                            name="majorsAll"
                                            checked={
                                                filters?.majors?.majorsAll ||
                                                false
                                            }
                                            onChange={(e) =>
                                                onChangeField(e, 'majors')
                                            }
                                            disabled={isLoading}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="majorsAll"
                                        >
                                            {Variable.ALL_MAJORS[ENV_NAME]}{' '}
                                            <span className="filter-count">{`(${majors?.length})`}</span>
                                        </label>
                                    </div>
                                </div>
                                {(majors || [])?.slice(0, 3)?.map((i, idx) => (
                                    <div
                                        className="form-group form-check"
                                        key={'majors-' + idx}
                                    >
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id={i.name}
                                                name={i.name}
                                                checked={
                                                    filters?.majors
                                                        ?.majorsAll ||
                                                    filters?.majors?.[i.name] ||
                                                    false
                                                }
                                                onChange={(e) =>
                                                    onChangeField(e, 'majors')
                                                }
                                                disabled={isLoading}
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={i.name}
                                            >
                                                {i.name}
                                                <span className="filter-count">
                                                    ({i?.count_majors})
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                ))}
                                {majors?.length > 5 && (
                                    <button
                                        className="btn btn-view-more"
                                        onClick={() =>
                                            openViewMore('majors', true)
                                        }
                                    >
                                        {Variable.VIEW_MORE_DOMESTIC[ENV_NAME]}{' '}
                                        {!!getSelectedFilterCount(
                                            filters.majors,
                                            true,
                                            false
                                        ) &&
                                            `(${getSelectedFilterCount(
                                                filters.majors,
                                                true,
                                                false
                                            )} ${Variable.APPLIED[ENV_NAME]})`}
                                    </button>
                                )}
                            </>
                        )}
                    </FilterBox>
                    <ViewMoreBox
                        open={viewMore?.majors || false}
                        onHide={() => openViewMore('majors', false)}
                        data={[
                            {
                                id: 'majorsAll',
                                name: Variable.ALL_MAJORS[ENV_NAME],
                                count_majors: majors?.length,
                            },
                            ...(majors?.map((i) => ({
                                id: i.name,
                                name: i.name,
                                count_majors: i.count_majors,
                            })) || []),
                        ]}
                        parent="majors"
                        filters={filters}
                        onSave={(data) =>
                            setFilters((p) => ({
                                ...p,
                                ...data,
                                majors: data?.majors,
                            }))
                        }
                        searchPlaceholder={Variable.SRC_MAJOR[ENV_NAME]}
                        withCount
                    />
                    {activeSwitcher === 'domestic' && (
                        <>
                            <FilterBox
                                header={Variable.ACCREDITATION[ENV_NAME]}
                                collapsible={1}
                                eventkey="0"
                                opendefault={1}
                            >
                                <div className="row mx-0">
                                    <div className="col-6 ps-0">
                                        {ACCREDITATION_OPT_LEFT?.map((i) => (
                                            <div
                                                className="form-group form-check"
                                                key={i?.id}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`${i?.id}`}
                                                    name={`${i?.id}`}
                                                    checked={
                                                        filters
                                                            ?.accreditation?.[
                                                            i?.id
                                                        ] || false
                                                    }
                                                    onChange={(e) =>
                                                        onChangeField(
                                                            e,
                                                            'accreditation'
                                                        )
                                                    }
                                                    disabled={isLoading}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`${i?.id}`}
                                                >
                                                    {i?.name}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-6 pe-0">
                                        {ACCREDITATION_OPT_RIGHT?.map((i) => (
                                            <div
                                                className="form-group form-check"
                                                key={i?.id}
                                            >
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={`${i?.id}`}
                                                    name={`${i?.id}`}
                                                    checked={
                                                        filters
                                                            ?.accreditation?.[
                                                            i?.id
                                                        ] || false
                                                    }
                                                    onChange={(e) =>
                                                        onChangeField(
                                                            e,
                                                            'accreditation'
                                                        )
                                                    }
                                                    disabled={isLoading}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={`${i?.id}`}
                                                >
                                                    {i?.name}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="divider mt-0 mb-sm" />
                                <div className="form-group form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="noAccreditation"
                                        name="noAccreditation"
                                        checked={
                                            filters?.accreditation?.[
                                                'noAccreditation'
                                            ] || false
                                        }
                                        onChange={(e) =>
                                            onChangeField(e, 'accreditation')
                                        }
                                        disabled={isLoading}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor="noAccreditation"
                                    >
                                        {Variable.NO_ACCREDITATION[ENV_NAME]}
                                    </label>
                                </div>
                            </FilterBox>
                            <ViewMoreBox
                                open={viewMore?.abroadAccreditation || false}
                                onHide={() =>
                                    openViewMore('abroadAccreditation', false)
                                }
                                // data={abroadAccreditations || []}
                                parent="abroadAccreditation"
                                filters={filters}
                                onSave={(data) =>
                                    setFilters((p) => ({
                                        ...p,
                                        ...data,
                                        abroadAccreditation:
                                            data?.abroadAccreditation,
                                        accreditation: {
                                            ...p?.accreditation,
                                            noAccreditation:
                                                Object.values(
                                                    data?.abroadAccreditation ||
                                                        {}
                                                )?.filter((i) => i)?.length > 0
                                                    ? false
                                                    : p?.accreditation
                                                          ?.noAccreditation,
                                        },
                                    }))
                                }
                                searchPlaceholder={
                                    Variable.SRC_ACCREDITATION[ENV_NAME]
                                }
                                // isLoading={isLoadingAccreditation}
                            />
                        </>
                    )}
                    <FilterBox
                        header={Variable.SCHOLARSHIP[ENV_NAME]}
                        collapsible={1}
                        eventkey="0"
                        opendefault={1}
                    >
                        <div className="form-group form-check">
                            <input
                                type="radio"
                                className="form-check-input"
                                id="allScholarship"
                                name="scholarship"
                                checked={
                                    filters?.scholarship === 'allScholarship' ||
                                    false
                                }
                                onChange={(e) =>
                                    onChangeField(e, 'scholarship', true)
                                }
                                disabled={isLoading}
                            />
                            <label
                                className="form-check-label"
                                htmlFor="allScholarship"
                            >
                                {Variable.SHOW_ALL[ENV_NAME]}
                            </label>
                        </div>
                        {SCHOLARSHIP_OPT?.map((i) => (
                            <div className="form-group form-check" key={i?.id}>
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id={`${i?.id}`}
                                    name="scholarship"
                                    checked={
                                        filters?.scholarship === `${i?.id}` ||
                                        false
                                    }
                                    onChange={(e) =>
                                        onChangeField(e, 'scholarship', true)
                                    }
                                    disabled={isLoading}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`${i?.id}`}
                                >
                                    {i?.name?.[ENV_NAME]}
                                </label>
                            </div>
                        ))}
                    </FilterBox>
                </>
            }
            contents={
                !isLoading && colleges?.length === 0 ? (
                    <NoContentComponent className="my-xl" description=" " />
                ) : (
                    (colleges || [])?.map((i, idx) => (
                        <Link
                            key={i?.id || idx}
                            to={
                                i?.id
                                    ? RoutePath.COLLEGE_DETAIL + '/' + i?.id
                                    : ''
                            }
                            className="text-decoration-none"
                        >
                            {view !== 'list' ? (
                                <CollegeCard
                                    isLoading={i?.isLoading}
                                    data={i?.isLoading ? undefined : i}
                                    onClickFavorite={() => {
                                        if (
                                            i?.isLoading ||
                                            fetchingAddRemoveFavorites
                                        )
                                            return
                                        if (isAuthenticated) {
                                            props.addRemoveFavorite(
                                                i?.is_favourite
                                                    ? 'remove'
                                                    : 'add',
                                                'college',
                                                i?.is_favourite
                                                    ? i?.fav_obj_id
                                                    : i?.id,
                                                (res) => {
                                                    setColleges((prev) =>
                                                        prev.map((p) => {
                                                            if (p?.id !== i?.id)
                                                                return p
                                                            return {
                                                                ...p,
                                                                is_favourite:
                                                                    !i?.is_favourite,
                                                                fav_obj_id:
                                                                    i?.is_favourite
                                                                        ? null
                                                                        : res
                                                                              ?.data
                                                                              ?.id,
                                                            }
                                                        })
                                                    )
                                                }
                                            )
                                        } else {
                                            props.openLoginModal()
                                        }
                                    }}
                                    onClick={() => {}}
                                    ENV_NAME={ENV_NAME}
                                    smallcard={view === 'small'}
                                />
                            ) : (
                                <CollegeListCard
                                    isLoading={i?.isLoading}
                                    data={i?.isLoading ? undefined : i}
                                    onClickFavorite={() => {
                                        if (
                                            i?.isLoading ||
                                            fetchingAddRemoveFavorites
                                        )
                                            return
                                        if (isAuthenticated) {
                                            props.addRemoveFavorite(
                                                i?.is_favourite
                                                    ? 'remove'
                                                    : 'add',
                                                'college',
                                                i?.is_favourite
                                                    ? i?.fav_obj_id
                                                    : i?.id,
                                                (res) => {
                                                    setColleges((prev) =>
                                                        prev.map((p) => {
                                                            if (p?.id !== i?.id)
                                                                return p
                                                            return {
                                                                ...p,
                                                                is_favourite:
                                                                    !i?.is_favourite,
                                                                fav_obj_id:
                                                                    i?.is_favourite
                                                                        ? null
                                                                        : res
                                                                              ?.data
                                                                              ?.id,
                                                            }
                                                        })
                                                    )
                                                }
                                            )
                                        } else {
                                            props.openLoginModal()
                                        }
                                    }}
                                    onClick={() => {}}
                                    ENV_NAME={ENV_NAME}
                                />
                            )}
                        </Link>
                    ))
                )
            }
            contentsClassName={
                !isLoading && colleges?.length === 0 ? 'no-grid' : undefined
            }
            showingLabel={`${total?.total_items || 0} ${
                Variable.COLLEGES[ENV_NAME]
            }`}
            showMoreOnClick={() => !isLoading && setPage((p) => p + 1)}
            hasMore={!isLoading ? total.has_next : false}
        />
    )
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated,
		ENV_NAME: state.auth.selectedEnvironment || "bhs",
		fetchingAddRemoveFavorites: state.auth.fetchingAddRemoveFavorites,
	};
};

const mapStateToDispatch = (dispatch) => {
	return {
		openLoginModal: () =>
			dispatch({
				type: ActionTypes.OPEN_LOGIN_MODAL,
			}),
		addRemoveFavorite: (action, type, id, onSuccess = null, onFail = null) =>
			dispatch({
				type: ActionTypes.ADD_REMOVE_FAVORITE,
				data: { action, type, id },
				onSuccess,
				onFail,
			}),
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(CollegeListing));
